import { useSelector } from 'react-redux'
import { updateReducerAndForm } from '../../services/subscription'
import Checkbox from '../checkbox'
import { StyledProducts } from './style'

const OrderProducts = ({ formikRef }) => {  
  const products = useSelector((state) => state.products)

  if(products.length && formikRef.current){
    let currentProducts = { ...formikRef.current.values.products }

    const toggle = (e, product) => {
      if(e.target.checked){
        currentProducts[product.id] = {
          quantity: 1,
          name: product.name,
          price: product.subscription_price
        }
      }
      else {
        delete currentProducts[product.id]
      }

      updateReducerAndForm({
        products: currentProducts,
      }, formikRef.current.setFieldValue)
    }

    return(
      <StyledProducts>
        {products.map((product, i) => {
          const style = {
            backgroundImage: `url(${product.subscription_banner_url.replace(':3000', ':3003')})`
          }

          return <div className="product" key={i} style={style}>
            <Checkbox
              checked={Boolean(formikRef.current.values.products[product.id])}
              onChange={(e) => toggle(e, product)}
              style="button"
              text="Adicionar"
            />

            <div className="stock-warning">
              Aproveite! Restam apenas <strong>{product.stock} unidades</strong> em estoque
            </div>
          </div>
        })}
      </StyledProducts>
    )
  }
  else return null
}

export default OrderProducts
